import styles from './ListMoreHoverIcon.module.scss'

const ListMoreHoverIcon = ({color = '#333'}) => {
  return (
    <div className={styles.container}>
      <svg width="14px" height="3px" viewBox="0 0 14 3" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>Button/List-more-hover</title>
          <g id="Button/List-more-hover" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <circle id="Oval" fill={color} transform="translate(12.500000, 1.500000) rotate(-270.000000) translate(-12.500000, -1.500000) " cx="12.5" cy="1.5" r="1.5"></circle>
              <circle id="Oval" fill={color} transform="translate(7.000000, 1.500000) rotate(-270.000000) translate(-7.000000, -1.500000) " cx="7" cy="1.5" r="1.5"></circle>
              <circle id="Oval" fill={color} transform="translate(1.500000, 1.500000) rotate(-270.000000) translate(-1.500000, -1.500000) " cx="1.5" cy="1.5" r="1.5"></circle>
          </g>
      </svg>
    </div>
  );
}

export default ListMoreHoverIcon;
